<div *ngIf="addressForm && isFormLoaded">
	<form [formGroup]="addressForm">
		<freud-input-text
			[formControl]="addressForm.controls.name"
			class="zk-block zk-mb-4"
			[label]="'PAGES.ADDRESS.NAME_LABEL' | translate"
			[placeholder]="'PAGES.ADDRESS.NAME_PLACEHOLDER' | translate"
		></freud-input-text>
		<div class="zk-flex zk-flex-col md:zk-flex-row zk-gap-2 zk-mb-4">
			<freud-input-mask
				(onComplete)="onPostalCodeChange()"
				[invalid]="
					addressForm.controls.postalCode.touched &&
					addressForm.controls.postalCode.status === 'INVALID'
				"
				[formControl]="addressForm.controls.postalCode"
				class="md:zk-w-3/5"
				mask="99999-999"
				label="CEP"
			></freud-input-mask>

			<freud-input-mask
				[invalid]="
					addressForm.controls.phone.touched &&
					addressForm.controls.phone.status == 'INVALID'
				"
				class="md:zk-w-2/5"
				mask="(99) 99999-999?9"
				[formControl]="addressForm.controls.phone"
				[label]="'PAGES.ADDRESS.PHONE_LABEL' | translate"
			></freud-input-mask>
		</div>
		<freud-input-text
			[invalid]="
				addressForm.controls.street.touched &&
				addressForm.controls.street.status === 'INVALID'
			"
			[formControl]="addressForm.controls.street"
			[disabled]="
				!!addressByPostalCode?.street ||
				isLoading ||
				(action === 'edit' && !addressForm.controls.street.dirty)
			"
			class="zk-block zk-mb-4"
			[label]="'PAGES.ADDRESS.STREET_LABEL' | translate"
		></freud-input-text>
		<div class="zk-flex zk-flex-col md:zk-flex-row zk-gap-2 zk-mb-4">
			<freud-input-mask
				[invalid]="
					addressForm.controls.number.touched &&
					addressForm.controls.number.status === 'INVALID'
				"
				[disabled]="
					!!addressByPostalCode?.number ||
					isLoading ||
					(action === 'edit' && !addressForm.controls.number.dirty)
				"
				[formControl]="addressForm.controls.number"
				class="md:zk-w-1/5"
				mask="9999"
				[label]="'PAGES.ADDRESS.STREET_NUMBER_LABEL' | translate"
			></freud-input-mask>
			<freud-input-text
				[formControl]="addressForm.controls.complement"
				[disabled]="isLoading"
				class="md:zk-w-4/5"
				[label]="'PAGES.ADDRESS.STREET_AMMEND_LABEL' | translate"
			></freud-input-text>
		</div>
		<freud-input-text
			[invalid]="
				addressForm.controls.neighborhood.touched &&
				addressForm.controls.neighborhood.status === 'INVALID'
			"
			[formControl]="addressForm.controls.neighborhood"
			[disabled]="
				!!addressByPostalCode?.neighborhood ||
				isLoading ||
				(action === 'edit' && !addressForm.controls.neighborhood.dirty)
			"
			class="zk-block zk-mb-4"
			[label]="'PAGES.ADDRESS.NEIGHBORHOOD_LABEL' | translate"
		></freud-input-text>
		<div class="zk-flex zk-flex-col md:zk-flex-row zk-gap-2">
			<freud-input-text
				[invalid]="
					addressForm.controls.city.touched &&
					addressForm.controls.city.status === 'INVALID'
				"
				[formControl]="addressForm.controls.city"
				[disabled]="
					!!addressByPostalCode?.city ||
					isLoading ||
					(action === 'edit' && !addressForm.controls.city.dirty)
				"
				class="md:zk-w-2/3"
				[label]="'PAGES.ADDRESS.CITY_LABEL' | translate"
			></freud-input-text>
			<freud-select
				[invalid]="
					addressForm.controls.state.touched &&
					addressForm.controls.state.status === 'INVALID'
				"
				placeholder="Selecione"
				optionLabel="value"
				optionValue="value"
				[options]="regions"
				[disabled]="
					!!addressByPostalCode?.state ||
					isLoading ||
					(action === 'edit' && !addressForm.controls.state.dirty)
				"
				[formControl]="addressForm.controls.state"
				class="md:zk-w-1/3"
				[label]="'PAGES.ADDRESS.STATE_LABEL' | translate"
			></freud-select>
		</div>
	</form>
</div>
